// sourced and extended from https://github.com/nkbt/react-works
import React from 'react'

type Props = {
    callback: () => void
    enabled?: boolean
    timeout?: number
}

export class ReactInterval extends React.Component<Props> {
    static defaultProps = {
        enabled: false,
        timeout: 1000,
    }

    private timer: ReturnType<typeof setTimeout> | null = null

    componentDidMount(): void {
        if (this.props.enabled) {
        this.start()
        }
    }

    shouldComponentUpdate(nextProps: Props): boolean {
        return (
        this.props.timeout !== nextProps.timeout ||
        this.props.callback !== nextProps.callback ||
        this.props.enabled !== nextProps.enabled
        )
    }

    componentDidUpdate(prevProps: Props): void {
        if (
        this.props.enabled !== prevProps.enabled ||
        this.props.timeout !== prevProps.timeout
        ) {
        if (this.props.enabled) {
            this.start()
        } else {
            this.stop()
        }
        }
    }

    componentWillUnmount(): void {
        this.stop()
    }

    private callback = () => {
        if (this.timer) {
        this.props.callback()
        this.start() // recursive timeout
        }
    }

    private start = () => {
        this.stop()
        this.timer = setTimeout(this.callback, this.props.timeout)
    }

    private stop = () => {
        if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
        }
    }

    render(): false {
        return false
    }
}